import { createSelector } from "@ngrx/store";
import { selectRationAutoCreationDiseasesState } from "../reducers";
import * as fromDiseases from "../reducers/ration-auto-creation-diseases.reducer";

export const selectRationAutoCreationDiseaseListIsLoading = () =>
  createSelector(
    selectRationAutoCreationDiseasesState(),
    fromDiseases.selectIsLoading,
  );

export const selectAllRationAutoCreationDiseases = () =>
  createSelector(
    selectRationAutoCreationDiseasesState(),
    fromDiseases.selectAll,
  );
